<h2 class="vl-card-header">
  <ng-content></ng-content>
</h2>